import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';

/** Providing localized strings */

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  public languageJSON: any;

  constructor(private settingsService: SettingsService) {
    this.settingsService.ObservableLanguage.subscribe((resp) => {
      if (resp) {
        this.languageJSON = require(`src/assets/json/language_${resp}.json`);
      }
    });
  }
}
